import {
  BooleanInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required
} from 'react-admin';
import { CustomEditor, UploadImageInput } from '../../components';

export default function ResponsibilityItemsForm(
  props: Partial<SimpleFormProps>
) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        fullWidth
        autoComplete="off"
        label="Título"
        source="title"
        validate={[required()]}
      />

      <CustomEditor
        fullWidth
        label="Descrição"
        source="description"
        validate={[required()]}
      />

      <UploadImageInput
        fullWidth
        label="Foto"
        source="photo"
        mimeTypes={['image/jpeg']}
        upploadOptions={{
          maxSize: [396, 203]
        }}
        cropOptions={{ aspectRatio: 396 / 203 }}
        helperText="É possível enviar imagens no formato JPEG com dimensões recomendadas de 396x203px."
      />

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
